(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  // Shopify injects this bundle into <head>, ahead of the theme's own assets, and both are
  // deferred — so at parse time `window.SearchEngine` does not exist yet. Waiting for
  // DOMContentLoaded puts this after every deferred script has run. Without it the engine check
  // below silently fails and the page quietly keeps Shopify's results.
  const startSearchSection = () => {
  document.querySelectorAll('[data-search-page]').forEach((results) => {
    const trigger = results.querySelector('[data-load-more]');
    const grid = results.querySelector('[data-search-grid]');
    const engine = window.SearchEngine;
    const cardTemplate = document.querySelector('[data-search-card-template]');
    const starRows = document.querySelector('[data-search-star-rows]');
    const query = results.dataset.query || '';

    // With the index configured, this page answers from it. Without it — or without the shared
    // card renderer — everything below falls through to the original Section Rendering behaviour
    // against Shopify's own search.
    if (engine && engine.isConfigured() && query && cardTemplate && grid && window.ProductCardRender) {
      hydrateFromIndex({ results, grid, trigger, engine, cardTemplate, starRows, query });
      return;
    }

    if (!trigger || !grid) return;

    const idleLabel = trigger.textContent;
    const loadingLabel = trigger.dataset.loadingLabel || idleLabel;
    let loading = false;

    trigger.addEventListener('click', async (event) => {
      event.preventDefault();

      if (loading) return;
      loading = true;
      trigger.textContent = loadingLabel;
      trigger.setAttribute('aria-busy', 'true');

      // The Section Rendering API returns this section alone for the requested page, so the
      // next batch of cards is markup the theme already knows how to draw — no client-side
      // card template to keep in sync with `product-card.liquid`.
      const separator = trigger.href.includes('?') ? '&' : '?';
      const url = `${trigger.href}${separator}section_id=${results.dataset.sectionId}`;

      try {
        const response = await fetch(url);

        if (!response.ok) throw new Error(`Search page request failed: ${response.status}`);

        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.querySelector('[data-search-grid]');
        const nextTrigger = page.querySelector('[data-load-more]');

        if (nextGrid) grid.append(...nextGrid.children);

        if (nextTrigger) {
          trigger.href = nextTrigger.href;
        } else {
          trigger.remove();
        }
      } catch (error) {
        console.error(error);
        // A failed append still has a working page-2 URL behind it — follow it rather than
        // leaving the shopper on a dead button.
        window.location.href = trigger.href;
      } finally {
        loading = false;
        trigger.textContent = idleLabel;
        trigger.removeAttribute('aria-busy');
      }
    });
  });
  };

  // Note `interactive`, not `loading`: a deferred script runs after parsing, so the document is
  // already interactive when this executes and an "is it still loading?" check would fire
  // immediately — ahead of theme.js and search-engine.js, which are deferred but later in the
  // document. DOMContentLoaded is the first moment every deferred script has run.
  if (document.readyState === 'complete') {
    startSearchSection();
  } else {
    document.addEventListener('DOMContentLoaded', startSearchSection);
  }

  /**
   * Replaces the Liquid grid with results from the search index, and turns Load more into a
   * pager over that index. Prices come from the engine's per-market lookup, never from the
   * index's own base-currency price.
   */
  function hydrateFromIndex(ctx) {
    const { results, grid, trigger, engine, cardTemplate, starRows, query } = ctx;
    const pageSize = Number(results.dataset.pageSize) || 20;
    const heading = document.querySelector('[data-search-heading]');
    const wrapper = results.querySelector('[data-load-more-wrapper]');
    const idleLabel = trigger ? trigger.textContent : '';
    const loadingLabel = trigger ? trigger.dataset.loadingLabel || idleLabel : '';

    let page = 0;
    let total = 0;
    let loading = false;

    // The card renderer is shared with the directory page rather than reimplemented here, so a
    // change to the card is made once. `layout/theme.liquid` loads it on this template.
    const buildCard = window.ProductCardRender.create({
      cardTemplate,
      starRows,
      engine,
    });

    const empty = results.querySelector('[data-search-empty]');
    const skeleton = results.querySelector('[data-search-skeleton]');

    /**
     * Ends the hydrating state: skeletons out, real content in. Safe to call more than once, and
     * called on failure too — falling back to Shopify's stale results beats leaving the page
     * showing placeholders forever.
     */
    // Whether the empty state belongs on screen once hydration ends. It starts at Shopify's own
    // answer, so an index that never replies leaves the page consistent with the results Liquid
    // rendered; `paint` moves it to the index's answer from there.
    let showEmpty = Number(results.dataset.fallbackCount || 0) === 0;

    const syncEmpty = () => {
      // Not while the skeletons are up — the guard is hiding everything, and `reveal` applies this
      // once for real at the end.
      if (results.hasAttribute('data-hydrating')) return;
      if (empty && empty.isConnected) {
        empty.style.display = showEmpty ? 'flex' : 'none';
      }
    };

    const reveal = () => {
      if (!results.hasAttribute('data-hydrating')) return;
      results.removeAttribute('data-hydrating');

      if (skeleton) skeleton.remove();
      [grid, wrapper].forEach((el) => {
        if (el && el.isConnected) el.style.display = '';
      });

      syncEmpty();

      // The guard replaced the count with an ellipsis to avoid flashing Shopify's number. If the
      // index never answered, that number is what the shopper is now looking at, so put it back.
      if (!headingSet) setHeading(results.dataset.fallbackCount || '0');
    };

    const paint = (documents, append) => {
      if (!append) grid.replaceChildren();
      documents.forEach((doc) => grid.appendChild(buildCard(doc)));

      // Only now that the cards are in the document — a `src` assigned to a detached lazy image
      // is dropped on the floor.
      window.ProductCardRender.attachImages(grid);

      // Both directions matter, because the two engines disagree in both directions. Shopify found
      // nothing but the index did — swap the empty state for the grid. Shopify found results the
      // index does not have — swap the grid back for the empty state, rather than revealing a
      // blank page under a "(0)" heading with nothing on it to click.
      showEmpty = grid.children.length === 0;

      grid.classList.toggle('hidden', showEmpty);
      grid.classList.toggle('grid', !showEmpty);
      syncEmpty();
    };

    let headingSet = false;

    const setHeading = (count) => {
      if (!heading || !heading.dataset.resultsLabel) return;
      heading.textContent = heading.dataset.resultsLabel.replace('__COUNT__', count);

      // The tab, from the same number. Rendered count-free by Liquid, so a page that never
      // hydrates simply keeps a title with no count in it rather than a wrong one.
      if (heading.dataset.titleLabel) {
        document.title = heading.dataset.titleLabel.replace('__COUNT__', count);
      }

      headingSet = true;
    };

    const loadPage = async (append) => {
      if (loading) return;
      loading = true;

      if (trigger && append) {
        trigger.textContent = loadingLabel;
        trigger.setAttribute('aria-busy', 'true');
      }

      try {
        page += 1;
        const result = await engine.search(query, { page, pageSize });
        total = result.total;

        // Prices first, so cards never paint with an empty price and then fill in.
        try {
          await engine.resolvePrices(result.documents);
        } catch (error) {
          console.warn('Search prices unavailable:', error);
        }

        // Then the first screenful of images, fetched while the skeleton is still covering for
        // them. Skipped on append: those cards land below the fold behind a "Loading…" button.
        if (!append) {
          await window.ProductCardRender.preload(result.documents, {
            count: window.ProductCardRender.firstScreenful(skeleton),
          });
        }

        paint(result.documents, append);
        setHeading(total);
        reveal();

        // The control starts hidden when Shopify had no further page, which says nothing about
        // the index — it may hold many more. Visibility follows the index's total from here.
        if (wrapper) {
          wrapper.classList.toggle('hidden', page * pageSize >= total);
        }
      } catch (error) {
        console.error('Search error:', error);
        page -= 1;
        // Show Shopify's own results rather than nothing: they may be stale or thinner than the
        // index's, but they are a real answer and they are already rendered.
        reveal();
      } finally {
        loading = false;
        if (trigger && trigger.isConnected) {
          trigger.textContent = idleLabel;
          trigger.removeAttribute('aria-busy');
        }
      }
    };

    if (trigger) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        loadPage(true);
      });
    }

    engine.warm();
    loadPage(false);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-thank-you"]) return;
  try {
    
  (function () {
    var params = new URLSearchParams(window.location.search);
    var orderNumber = params.get('order');
    var email = params.get('email');
    if (orderNumber) {
      document.getElementById('thank-you-order-number').textContent = 'Order ' + orderNumber;
    }
    if (email) {
      document.getElementById('thank-you-email').textContent = 'Confirmation sent to ' + email;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.products-section-wrapper').forEach(function (wrapper) {
    var tabs = wrapper.querySelectorAll('[data-filter]');
    var cards = wrapper.querySelectorAll('[data-product-card]');

    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', 'false');
          t.classList.remove('products-section__tab--active');
        });

        tab.setAttribute('aria-pressed', 'true');
        tab.classList.add('products-section__tab--active');

        var filter = tab.dataset.filter;

        cards.forEach(function (card) {
          if (filter === 'all') {
            card.removeAttribute('hidden');
          } else {
            var tags = (card.dataset.tags || '').split(',').map(function (t) {
              return t.trim();
            });
            card.toggleAttribute('hidden', !tags.includes(filter));
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
